<script>
import { IconExclamationCircle } from '@tabler/icons-vue';
import SurveyQuestionCheckboxes from '../../../../Student/Survey/partials/SurveyQuestionCheckboxes.vue';
import SurveyQuestionMultipleChoice from '../../../../Student/Survey/partials/SurveyQuestionMultipleChoice.vue';
import SurveyQuestionLinearScale from '../../../../Student/Survey/partials/SurveyQuestionLinearScale.vue';
import SurveyQuestionShortAnswer from '../../../../Student/Survey/partials/SurveyQuestionShortAnswer.vue';
import SurveyQuestionLongAnswer from '../../../../Student/Survey/partials/SurveyQuestionLongAnswer.vue';
import SurveyQuestionMultipleLongAnswer from '../../../../Student/Survey/partials/SurveyQuestionMultipleLongAnswer.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import PageSection from '@/Shared/PageSection.vue';
import SubmitFormButton from '../../../Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        AppWell,
        AppCard,
        PageSection,
        SubmitFormButton,
        IconExclamationCircle,
        checkboxes: SurveyQuestionCheckboxes,
        multiple_choice: SurveyQuestionMultipleChoice,
        linear_scale: SurveyQuestionLinearScale,
        short_answer: SurveyQuestionShortAnswer,
        long_answer: SurveyQuestionLongAnswer,
        multiple_long_answer: SurveyQuestionMultipleLongAnswer,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<template>
    <div class="mt-1">
        <PageSection>
            <template v-slot:title>
                {{ survey.title }}
            </template>
            <AppCard>
                <p class="whitespace-pre-line p-2">{{ survey.description }}</p>
            </AppCard>
        </PageSection>
        <div class="mt-5 flex flex-col gap-8">
            <PageSection v-for="section in survey.sections" :key="section.id">
                <template v-slot:title v-if="section.title">
                    {{ section.title }}
                </template>
                <template v-slot:subtitle v-if="section.subtitle">
                    {{ section.description }}
                </template>
                <div class="p-2">
                    <div class="mt-3 flex flex-col gap-4">
                        <div v-for="question in section.questions" :key="question.position">
                            <AppCard>
                                <div class="p-1">
                                    <div>
                                        <span>{{ question.title }}</span>
                                        <span v-if="question.is_required" class="text-red-600"> *</span>
                                    </div>
                                    <div v-if="question.description" class="mt-1">
                                        <p class="text-gray-700">{{ question.description }}</p>
                                    </div>
                                    <div v-show="false">
                                        {{ question.type }}
                                    </div>
                                    <div class="mt-3">
                                        <component :is="question.type" :question="question" v-model="question.answer" />
                                    </div>
                                </div>
                            </AppCard>
                        </div>
                    </div>
                </div>
            </PageSection>
        </div>
    </div>
</template>
